import { render } from "./upsell-popup.vue?vue&type=template&id=b77ed688"
import script from "./upsell-popup.vue?vue&type=script&lang=js"
export * from "./upsell-popup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__